module.exports = __webpack_public_path__ + "img/dianshangwangzhan.8c6e7cd7.png";